module.exports = __webpack_public_path__ + "static/giftcard-f9897b5e601f3c1520bbbb5670cd264c.png";